import Repository from './Repository'

const resource = 'email-exists'
const resourceUser = 'users'

export default {
  verifyEmail (email) {
    let params = {
      'email': email
    }
    return Repository.get(`${resource}`, { params: params })
  },
  getUsers (tenantId, params) {
    return Repository.get(`tenants/${tenantId}/${resourceUser}`, { params: params })
  },
  getUser (tenantId, userId, params) {
    return Repository.get(`tenants/${tenantId}/${resourceUser}/${userId}`, { params: params })
  },
  createUser (tenantId, data) {
    return Repository.post(`tenants/${tenantId}/${resourceUser}`, data)
  },
  updateUser (tenantId, userId, data) {
    return Repository.patch(`tenants/${tenantId}/${resourceUser}/${userId}`, data)
  }
}
